import { isPlatformBrowser } from '@angular/common';
import { Component, ViewChild, ElementRef, PLATFORM_ID, Inject } from '@angular/core';
import { trigger, transition, group, query, animate, style } from '@angular/animations';
import { PdvService } from '@app/services/pdv/pdv.service';
import { HostService } from '@app/services/host/host.service';
import { mapsService } from '@app/services/maps/maps.service';
declare var google;
@Component({
    selector: 'restaurant',
    templateUrl: 'restaurant.component.html',
    styleUrls: ['restaurant.component.scss'],
    animations: [
        trigger('zoomIn', [
            transition('* <=> *', [
                group([
                    query('.image', [
                        style({ opacity: 0, transform: 'translate(0,-100%)' }),
                    ], { optional: true }),
                    query('.comment', [
                        style({ opacity: 0, transform: 'translate(0,-10%)' }),
                    ], { optional: true }),

                    query('.livraison', [
                        style({ opacity: 0, transform: 'translate(0,-10%)' }),
                    ], { optional: true })
                ]),
                query('.image', [
                    animate('300ms ease-in', style({ opacity: 1, transform: 'translate(0,0)' }))
                ], { optional: true, delay: 100 }),
                query('.comment', [
                    animate('300ms ease-in', style({ opacity: 1, transform: 'translate(0,0)' }))
                ], { optional: true, delay: 100 }),
                query('.livraison', [
                    animate('300ms ease-in', style({ opacity: 1, transform: 'translate(0,0)' }))
                ], { optional: true, delay: 100 })
            ])
        ])
    ]
})
export class RestaurantComponent {
    pdv: any = {};
    host = "";
    imageSite: any;
    geocoder: any
    infowindow: any
    authorizedCities: any[];
    orderTypes: any[] = [];
    map: any;
    bounceOn: boolean = false;
    @ViewChild('maplink') maplink: ElementRef
    constructor(
        private pdvService: PdvService,
        private hostService: HostService,
        private mapsService: mapsService,
        @Inject(PLATFORM_ID) private platformId: Object
    ) {
        this.host = this.hostService.host2;
        this.pdvService.orderTypesAvailability.subscribe(orderTypes => {
            if (orderTypes) {
                this.orderTypes = orderTypes.filter(o => o.active);
            }
        });
        this.getCities();
        this.pdvService.pdv.subscribe(
            pdv => {
                this.pdv = pdv;
               this.mapsService.doSomethingGoogley(pdv.maps).then(
                    (data: any) => {
                        this.geocoder = new google.maps.Geocoder();
                        this.infowindow = new google.maps.InfoWindow();
                        this.map = new google.maps.Map(document.getElementById('map'), { zoom: 11 });
                        this.geocoder.geocode({ 'address': this.pdv.address }, (results, status) => {
                            if (status === 'OK') {
                                this.map.setCenter(results[0].geometry.location);
                                const marker = new google.maps.Marker({
                                    position: results[0].geometry.location,
                                    map: this.map,
                                    icon: 'assets/images/icon2.png',
                                    title: this.pdv.name
                                });
                                marker.addListener('click', () => {
                                    this.infowindow.setContent('<span>' + this.pdv.address + '</span>');
                                    this.infowindow.open(this.map, marker);
                                });
                            }
                        });
                        this.setCities();
                    }
                );
            }
        );
    }
    getCities() {
        this.pdvService.getAuthorizedCities().subscribe(
            (authorizedCities: any[]) => {
                this.authorizedCities = authorizedCities;
                this.setCities();
            }
        )
    }
    setCities() {
        setTimeout(
            () => {
                this.authorizedCities.forEach((zone, i) => {
                    this.geocoder.geocode({ 'address': zone.name + ' ' + zone.postalCode, region: 'FR' }, (results, status) => {
                        if (status == 'OK') {
                            this.map.setCenter(results[0].geometry.location);
                            var marker = new google.maps.Marker({
                                position: results[0].geometry.location,
                                map: this.map,
                                icon: 'assets/images/icon.png',
                                title: this.pdv.name
                            });
                            marker.addListener('click', () => {
                                this.infowindow.setContent("<p><b>" + zone.name + ',' + zone.postalCode + "</b></p><span>Min de commande " + zone.amountMiniDelivery + "€</span>");
                                this.infowindow.open(this.map, marker);
                            });
                        } else {
                            //console.log('Geocode was not successful for the following reason: ' + status);
                        }
                    });
                });
            }, 1000
        )
    }
    onpenMarker({ target: marker }) {
        marker.nguiMapComponent.openInfoWindow('iw', marker);
    }

    onMarkerInit(event) {
        setTimeout(
            () => {
                event.nguiMapComponent.openInfoWindow('iw', event);
            }, 200
        )
    }
    ngOnInit() {
        setTimeout(
            () => {
                var coords = this.pdv.address;
                coords = coords.replace(/\ /g, "+");
                this.maplink.nativeElement.setAttribute("href", this.GetMapUrl(coords));
            }, 200
        )
    }

    GetMapUrl(q) {
        if (isPlatformBrowser(this.platformId)) {
            var ua = navigator.userAgent.toLowerCase();
            var windows8 = ua.indexOf("windows nt 6.2") > -1
            var mobile = ua.indexOf("mobile") > -1 || ua.indexOf("wp7") > -1;
            var iPhone = ua.indexOf("iphone") > -1 || ua.indexOf("ipad") > -1;
            var android = ua.indexOf("android") > -1;
            var msie = ua.indexOf("msie") > -1;
            if (mobile && iPhone) return ("http://maps.google.com/maps?q=" + q);
            else if (mobile && android) return ("geo:0,0?q=" + q);
            else if (mobile && msie) return ("maps:" + q);
            else if (windows8) return ("bingmaps:?q=" + q); else
                return ("http://maps.google.com/maps?q=" + q);
        }
    }
    bounceOnFunction() {
        this.bounceOn = true;
        setTimeout(() => {
            this.bounceOn = false;
        }, 500)
    }
}
